import { TDynamicVariable } from "@shared/types";
import { OptionListItem, ProductOptionsData } from "../queryShaper.types";
import { QueriedCategory, QueryShapeItem, TakeoffItem } from "./query";
import { CoreConfig, TMinimumOptionList } from "./types";

export const categoryOutputVariable = (
  categories: QueriedCategory[]
): {
  quantity: TDynamicVariable[];
  categoryId: string;
  categoryQuantities: QueriedCategory["CategoryQuantities"];
}[] => {
  return categories.map((c) => {
    return {
      quantity: c.Quantity || [],
      categoryId: c._id,
      categoryQuantities: c.CategoryQuantities,
    };
  });
};

export const queryDataToCoreConfig = (
  takeoff: TakeoffItem,
  planpageshapes: QueryShapeItem[],
  parentData?: {
    takeoff: TakeoffItem;
    planpageshapes: QueryShapeItem[];
  }
): CoreConfig => {
  const parentConfig = parentData
    ? queryDataToCoreConfig(parentData.takeoff, parentData.planpageshapes)
    : undefined;
  const config: CoreConfig = {
    ProductConfiguration: takeoff.ProductConfiguration,
    //  TODO : objects are correct, types are not
    Shapes: (planpageshapes || []) as any[],
    categoryInput: categoryOutputVariable(takeoff?.Product?.Categories || []),
    linePostDistanceOnCenter: takeoff?.linePostDistanceOnCenter,
    cornerPostDistanceOnCenter: takeoff?.cornerPostDistanceOnCenter,
    parent: parentConfig,
  };
  return config;
};

export const productConfigurationToCoreConfig = (
  productOptions: ProductOptionsData,
  shapes?: [],
  takeoff?: TakeoffItem,
  parentData?: {
    productOptions: ProductOptionsData;
    shapes?: [];
    takeoff?: TakeoffItem;
  }
): CoreConfig => {
  const parentConfig = parentData
    ? productConfigurationToCoreConfig(
        parentData.productOptions,
        parentData.shapes,
        parentData.takeoff
      )
    : undefined;
  const config: CoreConfig = {
    ProductConfiguration: productOptions,
    //  TODO : objects are correct, types are not
    Shapes: (shapes || []) as any[],
    categoryInput: categoryOutputVariable(productOptions.Categories || []),
    linePostDistanceOnCenter: takeoff?.linePostDistanceOnCenter || 10,
    cornerPostDistanceOnCenter: takeoff?.cornerPostDistanceOnCenter || 300,
    parent: parentConfig,
  };
  return config;
};
